import * as constants from './constants';

const INITIAL_STATE = {
  showModal: false,
  shouldCheckCityBranch: false,
  feature: '',
};

const exportedObject = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_SHOW_MODAL:
      return Object.assign({}, state, {
        showModal: action.payload.showModal,
        shouldCheckCityBranch: action.payload.shouldCheckCityBranch,
        feature: action.payload.feature,
      });
    default:
      return state;
  }
};

export default exportedObject;
